module.exports = __webpack_public_path__ + "static/media/resume.e680c021.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resume.pdf
// module id = 102
// module chunks = 0